import type { ReactElement } from 'react';
import React from 'react';
import clsx from 'clsx';
import './skeleton.scss';

type Props = {
  isLoading?: boolean;
  isError?: boolean;
};

export default function Skeleton({ isLoading, isError }: Props): ReactElement {
  return (
    <div className={clsx('card skeleton', { loading: isLoading, error: isError })}>
      <div className="card-header">
        <div className="skeleton-box" style={{ width: '40ch' }} />
      </div>
      <div className="card-body">
        <svg
          viewBox="0 0 1000 600"
          style={{ background: 'white none repeat scroll 0% 0 %', fontSize: 12 }}
        >
          <g className="x-axis" transform="translate(0, 550)">
            <g
              className="axis"
              fill="none"
              fontSize="10"
              fontFamily="sans-serif"
              textAnchor="middle"
            >
              <path className="domain" stroke="currentColor" d="M72.5,6V0.5H222.5V6" />
            </g>
          </g>
          <g className="y-axis" transform="translate(72, 0)">
            <g className="scale" fill="none" fontSize="10" fontFamily="sans-serif" textAnchor="end">
              <path className="domain" stroke="currentColor" d="M0.5,550.5V50.5" />
            </g>
          </g>
          <g className="stage-ladder-graph" transform="translate(8,0)">
            <g>
              <g className="ladder" transform="translate(0,0)">
                <line
                  y1="91.91114836546522"
                  y2="508.0888516345348"
                  x1="0"
                  x2="0"
                  className="ladder-side"
                  stroke="black"
                />
                <line
                  y1="91.91114836546522"
                  y2="508.0888516345348"
                  x1="16"
                  x2="16"
                  stroke="black"
                  className="ladder-side"
                />
              </g>
            </g>
          </g>
          <g className="plot-area">
            <g className="learner-data">
              <g className="box-whisker">
                <g className="box">
                  <rect
                    x="122"
                    y="288.0553227158424"
                    width="50"
                    fill="none"
                    stroke="black"
                    strokeWidth="2px"
                    height="28.080469404861674"
                  />
                  <rect
                    x="122"
                    y="316.1357921207041"
                    width="50"
                    fill="none"
                    stroke="black"
                    strokeWidth="2px"
                    height="30.595138306789636"
                  />
                </g>
                <g className="whisker" opacity="1">
                  <line
                    x1="147"
                    x2="147"
                    y1="288.0553227158424"
                    y2="165.25565800502935"
                    stroke="black"
                    strokeWidth="1px"
                    strokeDasharray="3,3"
                  />
                  <line
                    x1="147"
                    x2="147"
                    y1="346.7309304274937"
                    y2="508.0888516345348"
                    stroke="black"
                    strokeWidth="1px"
                    strokeDasharray="3,3"
                  />
                </g>
              </g>
            </g>
          </g>
        </svg>
      </div>
    </div>
  );
}
